import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaFilePdf, FaDownload, FaLock } from 'react-icons/fa'; // Import lock icon
import "../../../styles/pages-styles/main-dashboard-pages-styles/texbook-style/TextBook.css";
import { useNavigate } from "react-router-dom";

const TextBook = () => {
    const [textbooks, setTextbooks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [subscriptionRequired, setSubscriptionRequired] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchTextbooks = async () => {
            const userId = sessionStorage.getItem("userId");
            setLoading(true);
            setError(null);
            setSubscriptionRequired(false); // Reset this state on each fetch attempt
            try {
                const response = await axios.get(`/user/fetch-textbooks/${userId}`);
                setTextbooks(response.data);
            } catch (err) {
                if (err.response && err.response.status === 402) {
                    setSubscriptionRequired(true);
                } else {
                    setError(err.message);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchTextbooks();
    }, []);

    if (loading) {
        return <div>Loading textbooks...</div>;
    }

    if (error) {
        return <div>Error loading textbooks: {error}</div>;
    }

    if (subscriptionRequired) {
        return (
            <div className="subscription-required-container">
                <FaLock className="lock-icon" />
                <h2 className="subscription-heading">Unlock a World of Knowledge</h2>
                <p className="subscription-message">
                    Access to our comprehensive textbook library requires a premium subscription.
                </p>
                <p className="subscription-benefit">
                    Upgrade now to instantly view and download all available textbooks to enhance your learning journey.
                </p>
                <button 
                  className="upgrade-button"
                  onClick={() => {
                    navigate("/dashboard/subscribe")
                  }}>Upgrade to Premium</button>
                {/* You can add more details or benefits of the premium plan here */}
            </div>
        );
    }

    return (
        <div className="textbook-container">
            <h1 className="textbook-heading">Your Textbooks</h1>
            <div className="table-container">
                <table className="textbook-table">
                    <thead>
                        <tr>
                            <th>TextBook</th>
                            <th>Description</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {textbooks.map((book) => (
                            <tr key={book._id}>
                                <td className="book-title">{book.name}</td>
                                <td className="book-description">{book.description}</td>
                                <td className="book-actions">
                                    <a
                                        href={book.pdfLink}
                                        className="view-button"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        title="View PDF"
                                    >
                                        <FaFilePdf />
                                    </a>
                                    <a
                                        href={book.pdfLink.replace("/upload/", "/upload/fl_attachment/")}
                                        className="download-button"
                                        download={`${book.name}.pdf`}
                                        title="Download PDF"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaDownload />
                                    </a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TextBook;
